import { jsxs as s, jsx as i, Fragment as w } from "react/jsx-runtime";
import y, { useCallback as E, useMemo as h } from "react";
import oe from "@mui/material/Menu";
import ce from "@mui/material/FormControl";
import ue from "@mui/material/ListSubheader";
import { isEqual as I } from "lodash";
import F from "@mui/icons-material/KeyboardArrowDown";
import se from "@mui/icons-material/Close";
import de from "@mui/icons-material/Search";
import { Box as a } from "../../atoms/Box/Box.js";
import { Checkbox as he } from "../../atoms/Checkbox/Checkbox.js";
import { FormLabel as fe } from "../../atoms/FormLabel/FormLabel.js";
import { Grid as me } from "../../atoms/Grid/Grid.js";
import { Typography as S } from "../../atoms/Typography/Typography.js";
import { styles as c } from "../../atoms/Select/Select.styles.js";
import { searchSelectorStyles as l, getSearchSelectorChevronSx as U } from "./SearchSelector.styles.js";
const H = (e) => {
  if (typeof e == "string") return e;
  const r = e, d = r.value;
  return d && typeof d == "object" && "id" in d ? String(d.id) : String(typeof d == "string" || typeof d == "number" ? d : r.label);
}, B = (e) => typeof e == "string" ? e : String(e.label), Pe = (e) => {
  const {
    variant: r = "outlined",
    size: d = "small",
    valueLayout: g = "ellipsis"
  } = e, X = e.capitalize !== !1, W = d === "medium" ? "40px" : "32px", b = e.width !== void 0 && e.width !== null, C = !!e.fullWidth && !b, M = b ? e.width : C ? "100%" : "auto", [L, P] = y.useState(null), [V, K] = y.useState(""), q = y.useRef(null), O = y.useRef(null), j = !!L, x = e.value === void 0 || e.value === null || e.value === "" || Array.isArray(e.value) && e.value.length === 0, N = !C && !b && x ? c.emptySelectMinWidth : void 0;
  y.useEffect(() => {
    if (j) {
      const t = window.setTimeout(() => q.current?.focus(), 0);
      return () => window.clearTimeout(t);
    }
  }, [j]);
  const Z = E((t) => {
    P(t.currentTarget);
  }, []), z = E(() => {
    P(null), K("");
  }, []), T = h(() => {
    const t = V.trim().toLowerCase();
    return t ? e.searchAccessor ? e.options.filter((n) => e.searchAccessor(n, t)) : e.options.filter((n) => B(n).toLowerCase().includes(t)) : e.options;
  }, [e.options, V, e.searchAccessor]), v = h(() => {
    if (!e.multiple) return [];
    const t = e.value;
    if (t.length === 0) return [];
    const n = e.options.some((u) => typeof u != "string"), o = t.every((u) => typeof u == "string");
    if (!n || !o) return t;
    const m = new Set(t.map((u) => String(u)));
    return e.options.filter((u) => typeof u == "string" ? m.has(u) : m.has(String(u.value)));
  }, [e.multiple, e.options, e.value]), k = E((t) => e.multiple ? v.some((n) => I(n, t)) : typeof e.value == "string" && typeof t != "string" ? I(t.value, e.value) : I(e.value, t), [e.multiple, e.value, v]), p = E((t) => {
    if (e.multiple) {
      const n = k(t) ? v.filter((o) => !I(o, t)) : [...v, t];
      e.onChange(n);
      return;
    }
    e.onChange(t), z();
  }, [e.multiple, e.onChange, k, v, z]), G = h(() => {
    const t = {};
    for (const n of T) {
      if (typeof n == "string") continue;
      const o = n;
      o.group && (t[o.group] ??= []).push(o);
    }
    return Object.entries(t);
  }, [T]), _ = h(() => {
    if (e.multiple) return !1;
    const t = e.value;
    if (t == null || t === "") return !1;
    if (typeof t == "object" && "value" in t) {
      const n = t.value;
      return n != null && n !== "";
    }
    return !0;
  }, [e.multiple, e.value]), ee = (t) => {
    t.stopPropagation(), !e.multiple && e.onChange("");
  }, Q = h(() => {
    if (x) return e.placeholder ?? "";
    if (typeof e.value == "string") {
      if (e.options.length > 0 && typeof e.options[0] == "object") {
        const t = e.options.find((n) => typeof n != "string" && String(n.value) === e.value);
        if (t && typeof t != "string") return t.label;
      }
      return e.value;
    }
    return typeof e.value == "object" ? e.value.label : String(e.value);
  }, [e.options, e.value, e.placeholder, x]), R = h(() => {
    if (e.multiple) return null;
    if (typeof e.value == "object" && e.value !== null)
      return e.value.icon ?? null;
    if (typeof e.value == "string" && e.value) {
      const t = e.options.find((n) => typeof n == "string" ? !1 : I(n.value, e.value));
      if (t && typeof t != "string") return t.icon ?? null;
    }
    return null;
  }, [e.multiple, e.value, e.options]), f = e.multiple, Y = !f && !!e.clearable && _, A = !f && !!e.clearable, te = h(() => {
    const t = !f && r !== "none" && g !== "wrap" && !e.clearable, n = {
      width: b ? e.width : C ? "100%" : void 0,
      height: e.height ?? (t ? W : void 0)
    }, o = f ? {
      height: "auto",
      minHeight: "32px",
      overflow: "visible",
      flexWrap: "wrap",
      py: "4px"
    } : {}, m = !f && g === "wrap" ? {
      height: "auto",
      minHeight: W,
      alignItems: "flex-start",
      overflow: "visible"
    } : {}, u = A && r !== "none" ? {
      paddingRight: "8px"
    } : {}, J = A && r !== "none" ? [l.clearableTrigger, {
      minHeight: W
    }] : [];
    if (r === "none")
      return [c.selectControlSurfaceNone, n, {
        position: "relative"
      }, o, m, u, ...J];
    const D = [c.selectControlSurface, n, o, m, u, ...J];
    return r === "filled" ? [...D, c.selectControlSurfaceFilled] : r === "outlined" ? [...D, c.selectControlSurfaceOutlined] : D;
  }, [r, f, b, e.width, C, e.height, e.clearable, g, W, A]), ne = h(() => {
    if (e.autoWidth) return l.menuPaper;
    const t = O.current?.offsetWidth;
    return t ? [l.menuPaper, {
      minWidth: `${t}px`
    }] : l.menuPaper;
  }, [e.autoWidth, L]), le = X ? {
    textTransform: "capitalize"
  } : void 0, $ = (t, n, o) => {
    const m = typeof t != "string" && !!t.disabled, u = e.renderOption ? e.renderOption(t, n) : /* @__PURE__ */ s(w, { children: [
      e.startIcon ? /* @__PURE__ */ i(a, { component: "span", sx: l.startIcon, children: e.startIcon }) : typeof t != "string" && t.icon ? /* @__PURE__ */ i(a, { component: "span", sx: l.startIcon, children: t.icon }) : null,
      /* @__PURE__ */ i(S, { sx: {
        fontSize: "12px",
        fontWeight: 400
      }, children: B(t) })
    ] });
    return /* @__PURE__ */ s(a, { onClick: () => {
      m || p(t);
    }, sx: [l.optionRow, n && l.optionRowSelected, m && l.optionRowDisabled], style: le, children: [
      f && /* @__PURE__ */ i(he, { checked: n, size: "small", sx: l.compactCheckbox, tabIndex: -1, onChange: () => {
      } }),
      u
    ] }, o);
  }, ie = /* @__PURE__ */ s(a, { sx: [l.triggerActions, ...r === "none" ? [{
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    marginLeft: 0
  }] : []], children: [
    Y ? /* @__PURE__ */ i(se, { sx: l.clearIcon, onClick: ee, "aria-label": "Clear selection" }) : null,
    /* @__PURE__ */ i(F, { sx: [l.chevronIcon, r === "none" && l.chevronIconNone] })
  ] }), re = /* @__PURE__ */ i(w, { children: f ? /* @__PURE__ */ s(w, { children: [
    /* @__PURE__ */ s(a, { sx: l.multiChips, children: [
      v.length === 0 && e.startIcon ? /* @__PURE__ */ i(a, { component: "span", sx: l.startIcon, children: e.startIcon }) : null,
      v.map((t) => /* @__PURE__ */ s(a, { component: "span", sx: l.chip, onClick: (n) => n.stopPropagation(), children: [
        e.startIcon ? /* @__PURE__ */ i(a, { component: "span", sx: l.startIcon, children: e.startIcon }) : null,
        /* @__PURE__ */ i(S, { component: "span", sx: l.chipText, children: B(t) })
      ] }, H(t)))
    ] }),
    /* @__PURE__ */ i(F, { sx: U(r === "none") })
  ] }) : A ? /* @__PURE__ */ s(w, { children: [
    /* @__PURE__ */ s(a, { sx: [l.valueText, ...r === "none" || g === "wrap" ? [l.valueTextWrap] : [], ...r === "none" && Y ? [{
      paddingRight: "44px"
    }] : []], children: [
      e.startIcon || R ? /* @__PURE__ */ i(a, { component: "span", sx: l.startIcon, children: e.startIcon ?? R }) : null,
      !x && e.renderSelectedValue ? /* @__PURE__ */ i(a, { component: "span", sx: l.valueLabel, children: e.renderSelectedValue(e.value) }) : /* @__PURE__ */ i(S, { component: "span", sx: [l.valueLabel, x && l.placeholderText], children: Q })
    ] }),
    ie
  ] }) : /* @__PURE__ */ s(w, { children: [
    /* @__PURE__ */ i(a, { component: "span", sx: [c.valueRoot, (r === "none" || g === "wrap") && c.valueRootWrap], children: /* @__PURE__ */ s(a, { component: "span", sx: c.selectedContainer, children: [
      e.startIcon || R ? /* @__PURE__ */ i(a, { component: "span", sx: l.startIcon, children: e.startIcon ?? R }) : null,
      !x && e.renderSelectedValue ? /* @__PURE__ */ i(a, { component: "span", sx: g === "wrap" ? c.valueTextWrap : c.valueTextEllipsis, children: e.renderSelectedValue(e.value) }) : /* @__PURE__ */ i(S, { component: "span", sx: [g === "wrap" ? c.valueTextWrap : c.valueTextEllipsis, x && l.placeholderText], children: Q })
    ] }) }),
    /* @__PURE__ */ i(F, { sx: U(r === "none") })
  ] }) }), ae = h(() => ({
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: M,
    ...N
  }), [M, N]);
  return /* @__PURE__ */ s(ce, { variant: r === "none" ? "standard" : r, hiddenLabel: !0, fullWidth: C, sx: ae, children: [
    e.label ? /* @__PURE__ */ i(fe, { component: "legend", sx: c.label, children: e.label }) : null,
    /* @__PURE__ */ i(a, { ref: O, sx: te, style: e.style, onClick: Z, role: "button", tabIndex: 0, onKeyDown: (t) => {
      (t.key === "Enter" || t.key === " ") && (t.preventDefault(), O.current && P(O.current));
    }, children: re }),
    /* @__PURE__ */ s(oe, { open: j, anchorEl: L, onClose: z, slotProps: {
      paper: {
        sx: ne
      }
    }, MenuListProps: {
      sx: {
        padding: 0
      }
    }, disableAutoFocus: !0, children: [
      /* @__PURE__ */ s(a, { sx: l.searchRow, children: [
        /* @__PURE__ */ i("input", { ref: q, type: "text", value: V, onChange: (t) => K(t.target.value), onKeyDown: (t) => t.stopPropagation() }),
        /* @__PURE__ */ i(de, { sx: l.searchIcon })
      ] }),
      /* @__PURE__ */ i(a, { sx: l.optionsScroll, children: T.length === 0 ? /* @__PURE__ */ i(S, { sx: l.emptyState, children: e.emptyStateText ?? "No options available" }) : G.length ? G.map(([t, n]) => /* @__PURE__ */ s(y.Fragment, { children: [
        /* @__PURE__ */ i(ue, { component: "div", sx: c.groupHeader, children: /* @__PURE__ */ i(me, { container: !0, sx: c.groupHeaderContainer, children: /* @__PURE__ */ i(S, { sx: c.groupHeaderText, children: t }) }) }),
        n.map((o) => $(o, k(o), H(o)))
      ] }, t)) : T.map((t) => $(t, k(t), H(t))) })
    ] })
  ] });
};
export {
  Pe as default
};
